import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'status',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `status`,
    method: 'get',
    params: queriesParams
  })
}

export function show (id) {
  return request({
    url: `status/${id}`,
    method: 'get'
  })
}

export function add (data) {
  return request({
    url: 'status',
    method: 'post',
    data
  })
}

export function edit (id, data) {
  return request({
    url: `status/${id}`,
    method: 'patch',
    data
  })
}